module.exports = __webpack_public_path__ + "img/c_03.74323cdd.jpg";